import useApp from "../../hooks/useApp";
import { CheckGreen } from "../../assets/svgs";
import "./styles.scss";

const EligibilityCards = ({ activeTabIndex }) => {
  const { eligibilityPolicyData } = useApp();

  return (
    <div className="eligibility-cards-container">
      {eligibilityPolicyData[activeTabIndex].data && eligibilityPolicyData[activeTabIndex].data.map(item => {
        return (
          <div className="eligibility-card">
            <span className="eligibility-text">{item.message_key}</span>
            {item.is_eligible && (
              <img
                src={CheckGreen}
                alt="eligibility-check"
                className="eligibility-check"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default EligibilityCards;
